module.exports = __webpack_public_path__ + "media/images/xpass/brand_previews/cyclebar-e72faba76f89bb7114981027993e8db3.jpg";